<template>
  <section v-if="products.length" class="section" id="product-variations">
    <div class="container-lg">
      <div class="section__header  mb-12">
        <h2 class="section__title">{{ in18['page_product_variations'] }}</h2>
      </div>

      <div class="variations-table">
        <div v-for="product, i in products" class="variations-table__row">
          <div class="variations-table__col">
            <div class="variations-table__data">
              <img @click="openImageGallery(i)"
                  :alt="product.alt"
                   :src="product.image.source"
                   class="variations-table__image cursor-zoom-in aspect-square object-contain"
                   height="75"
                   width="75"
              >
              <div>
                <div class="variations-table__title">
                  {{ product.title }}
                  <div>{{ product.code }}</div>
                </div>
                <ul class="product__data  product__data--sm">
                  <li v-if="product.sizes" class="product_data-item">
                    {{ product.formatted_sizes }}
                  </li>
                  <li v-if="product.weight" class="product_data-item">
                    {{ product.formatted_weight }}
                  </li>
                  <li v-for="property in product.properties" class="product_data-item">
                    <b> {{ property.property_title }}</b>:
                    {{ property.option_value }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="variations-table__col">
            <ul class="product__data">
              <li class="product_data-item">
                {{ in18['page_availability'] }}
                <span :class="['fw-500 no-wrap', stockStatusClass(product)]">
                    {{ stockStatusText(product) }}
                </span>
              </li>
            </ul>
          </div>

          <div class="variations-table__col">
            <product-price :class-name="'variations-table__price'" :prices="product.prices"/>
          </div>

          <div class="variations-table__col  text-right">
            <add-to-cart-button
                v-if="product.quantity > 0 || product.virtual_quantity > 0"
                :class="'btn  btn--icon  btn--green  btn--block'"
                :in18="in18"
                :product-id="product.id"
                :title="in18['page_add_to_cart']"
            >
              <img alt="" src="/shop/images/add-to-cart.svg">
            </add-to-cart-button>
            <button v-else class="btn  btn--primary-outline  no-wrap  fw-400" type="button"
                    @click="selectVariation(product)">
              {{ in18['page_apply_for_notification'] }}
            </button>
          </div>
        </div>
      </div><!-- /.variations-table -->
    </div><!-- /.container -->
    <image-fullscreen-slider
        ref="variantGalleryRef"
        :imgSrcList="[variantPreviewImage]"
        :product="product"
    />
  </section>
</template>

<script>
import AddToCartButton from "./AddToCartButton.vue";

export default {
  name:       "ProductVariations",
  components: {
    'add-to-cart-button': AddToCartButton,
  },
  props:      {
    product: Object,
    in18:    {
      type: Object,
    },
  },
  data() {
    return {
      products: this.product['variations'] || [],
      variantPreviewImage: null
    }
  },
  emits:   [
    'change-active-product'
  ],
  methods: {
    selectVariation(product) {
      this.$emit('change-active-product', product);
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    stockStatusText(product) {
      if(product.quantity > 0) {
        return this.in18['page_product_in_shop'];
      } else if(product.virtual_quantity > 0) {
        return this.in18['page_product_in_stock'];
      } else {
        return this.in18['page_product_to_order'];
      }
    },
    stockStatusClass(product) {
      return product.quantity > 0 || product.virtual_quantity > 0
          ? 'text-green'
          : 'text-red';
    },
    openImageGallery(i) {
      this.variantPreviewImage = this.products[i]?.images?.large[0]?.webp;
      this.$refs.variantGalleryRef.openGallery();
    },
  },
}
</script>
